<template>
  <section class="courses-in-progress-box">
    <div class="container">
      <PrimarySectionTitle>
        <h2>Conteúdo ao vivo exclusivo para assinantes</h2>
      </PrimarySectionTitle>

      <div class="row">
        <div class="col-lg-6 mb-lg-0 mb-4">
          <picture class="embed-responsive embed-responsive-16by9">
            <img class="embed-responsive-item" src="https://i.imgur.com/PTa0Zud.png" alt="">
          </picture>
        </div>
        <div class="col-lg-6 d-flex text-center text-lg-left flex-column justify-content-between">
          <div>
            <PrimarySectionTitle class="text-center text-lg-left">
              <h2>Empreender na prática</h2>
              <h3>com <b>Peter Jordan</b></h3>
            </PrimarySectionTitle>
            <PrimaryButton tag="a" href="#">
              Voltar a assistir
            </PrimaryButton>
          </div>
          <ul class="dots-box justify-content-center justify-content-lg-start">
            <li class="dot-item active"></li>
            <li class="dot-item"></li>
            <li class="dot-item"></li>
            <li class="dot-item"></li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import PrimarySectionTitle from '@/components/layout/PrimarySectionTitle'
  import PrimaryButton from '@/components/buttons/PrimaryButton'


  export default {
    components: {
      PrimarySectionTitle,
      PrimaryButton,
    }
  }
</script>

<style scoped lang="scss">
  @import '~@/assets/sass/variables';

  .courses-in-progress-box {
    .dots-box {
      margin-top: 40px;
      width: auto;
      display: inline-flex;

      .dot-item {
        width: 20px;
        height: 20px;
        border-radius: 100%;
        background-color: #CDCDCD;
        cursor: pointer;

        &.active {
          background-color: #949494;
        }

        &:not(:last-child) {
          margin-right: 12px;
        }
      }
    }
  }
</style>